import { Typography } from '@mui/material'
import { CalendarStatus } from '@prisma/client'
import { getRaceStatus } from 'components/Dashboard/Races/Status/getRaceStatus'
import { getShowRaceStock } from 'components/Dashboard/Races/Status/showRaceStock'
import { Status } from 'components/common/Status/Status'
import RaceCard from 'components/event/RaceCard/RaceCard'
import { LightGroup } from 'domain/models/Group/EntityGroup'
import { Sponsor } from 'domain/models/Sponsor/Sponsor'
import { NonNullLiveEdition } from 'services/api/database/EventService'
import { DATE_TO_BE_CONFIRMED } from './Races'

interface RaceProps {
  date: string
  racesForDate: NonNullLiveEdition['races']
  editionRegistrationOpeningDate: Date | null
  editionRegistrationClosingDate: Date | null
  buildCtaRegisterLink: (
    slug: string | undefined | null
  ) => string | undefined | null
  websiteUrl?: string | null
  facebookUrl?: string | null
  isFeatured: boolean | null
  sponsors?: Sponsor[]
  calendarStatus: CalendarStatus
  group: LightGroup | null
}

const Race = ({
  date,
  racesForDate,
  editionRegistrationClosingDate,
  editionRegistrationOpeningDate,
  buildCtaRegisterLink,
  websiteUrl,
  facebookUrl,
  isFeatured,
  sponsors,
  group
}: RaceProps) => {
  return (
    <div>
      {date === DATE_TO_BE_CONFIRMED ? null : (
        <Typography variant="h5" marginBottom="27px" marginTop="23px">
          {date}
        </Typography>
      )}

      {racesForDate.map((race, index) => {
        const { slug } = race

        const raceForStatuses = {
          isArchived: race.isArchived,
          isActive: race.isActive,
          registrationOpeningDate: race.registrationOpeningDate
            ? race.registrationOpeningDate
            : null,
          registrationClosingDate: race.registrationClosingDate
            ? race.registrationClosingDate
            : null,
          editionRegistrationOpeningDate: editionRegistrationOpeningDate
            ? editionRegistrationOpeningDate
            : null,
          editionRegistrationClosingDate: editionRegistrationClosingDate
            ? editionRegistrationClosingDate
            : null,
          registrationsCount: race.attendeeCounts,
          raceStockInventory: race.raceInventory,
          group,
          withProjected: true,
          minTeamSize: race.minTeamSize,
          raceSegmentsLength: race.raceSegments.length,
          raceWaitingListConfiguration: race.raceWaitingListConfiguration,
          priceType: race.priceType,
          stockDisplayThreshold: race.stockDisplayThreshold,
          stockDisplayThresholdValue: race.stockDisplayThresholdValue,
          isWaitingList: race.raceWaitingListConfiguration?.enabled ?? false
        }

        const raceStatus = getRaceStatus(raceForStatuses)
        const showRaceStock = getShowRaceStock(raceForStatuses)

        const registerCtaLink = buildCtaRegisterLink(slug)
        const defaultLink = websiteUrl ? websiteUrl : facebookUrl
        const isRaceOnline =
          raceStatus === Status.ONLINE ||
          raceStatus === Status.OUT_OF_STOCK ||
          raceStatus === Status.WAITING_LIST
        const raceCtaLink =
          isFeatured && isRaceOnline ? registerCtaLink : defaultLink

        return (
          <RaceCard
            key={`event_card-${slug ?? index}`}
            race={race}
            ctaLink={raceCtaLink ?? '/'}
            sponsors={sponsors}
            raceStatus={raceStatus}
            cardType="FULL"
            isFeatured={isFeatured}
            showRaceStock={showRaceStock}
            groupRegistrationOpeningDate={group?.registrationOpeningDate}
          />
        )
      })}
    </div>
  )
}

export default Race
